'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LanguageSelector;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Dropdown = require('../dropdown/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Icon = require('../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Menu = require('../menu/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Tooltip = require('../tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _LanguageContext = require('./LanguageContext');

var _LanguageDictionary = require('./LanguageDictionary');

var _LanguageDictionary2 = _interopRequireDefault(_LanguageDictionary);

var _TextTranslate = require('./TextTranslate');

var _TextTranslate2 = _interopRequireDefault(_TextTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LanguageSelector(_ref) {
    var languages = _ref.languages,
        onChange = _ref.onChange,
        tooltip = _ref.tooltip,
        renderBody = _ref.renderBody;

    var _useContext = (0, _react.useContext)(_LanguageContext.LanguageContext),
        userLanguage = _useContext.userLanguage,
        userLanguageChange = _useContext.userLanguageChange;

    // set selected language by calling context method


    var handleLanguageChange = function handleLanguageChange(value) {
        onChange && onChange(value, function () {
            _LanguageDictionary2.default.setUserLanguage(value);
            userLanguageChange(value);
        });
    };

    var renderContent = function renderContent() {
        if (renderBody) {
            return renderBody();
        }
        return tooltip ? _react2.default.createElement(
            _Tooltip2.default,
            { title: _react2.default.createElement(_TextTranslate2.default, { text: tooltip }) },
            _react2.default.createElement(_Icon2.default, {
                type: 'global',
                style: { fontSize: 18, color: 'var(--main-color)' }
            })
        ) : _react2.default.createElement(_Icon2.default, {
            type: 'global',
            style: { fontSize: 18, color: 'var(--main-color)' }
        });
    };

    (0, _react.useEffect)(function () {
        // let defaultLanguage = window.localStorage.getItem('rcml-lang');
        // if (!defaultLanguage) {
        //     defaultLanguage = window.navigator.language.substring(0, 2);
        // }
        // userLanguageChange(defaultLanguage);
    }, [userLanguageChange]);

    return _react2.default.createElement(
        _Dropdown2.default,
        {
            overlay: _react2.default.createElement(
                _Menu2.default,
                {
                    selectedKeys: [userLanguage]
                },
                languages.map(function (language) {
                    return _react2.default.createElement(
                        _Menu2.default.Item,
                        {
                            key: _lodash2.default.get(language, 'key'),
                            onClick: function onClick() {
                                return handleLanguageChange(_lodash2.default.get(language, 'key'));
                            }
                        },
                        _react2.default.createElement(
                            'div',
                            { style: { display: 'flex', alignItems: 'center' } },
                            _react2.default.isValidElement(_lodash2.default.get(language, 'icon')) ? _lodash2.default.get(language, 'icon') : _react2.default.createElement(_Icon2.default, { type: _lodash2.default.get(language, 'icon.type') }),
                            _lodash2.default.get(language, 'name')
                        )
                    );
                })
            ),
            trigger: ['click'],
            placement: 'bottomRight'
        },
        _react2.default.createElement(
            'span',
            { style: { display: 'inline-block', textAlign: 'center', width: 40, cursor: "pointer" } },
            renderContent()
        )
    );
}